<template>
  <span>
    <!-- {{idInstalacion}} -->
  </span>
</template>

<script>
export default {
  props: {
    idInstalacion: {
      type: Number,
      required: true,
    }
  },
  data() {
    return {
      ultimoIdInstalacionMonitorizado: 0
    }
  },
  watch: {
    idInstalacion() {
      // console.log('Último='+this.ultimoIdInstalacionMonitorizado);
      // console.log('Nuevo='+this.idInstalacion);
      this.desconectarDeUltimaInstalacion();
      this.monitorizarInstalacion();
    }
  },
  methods: {
    desconectarDeUltimaInstalacion() {
      if (this.ultimoIdInstalacionMonitorizado > 0)
        this.$sagabroker.bajaSuscripcionTemas (["aparcamiento/"+this.ultimoIdInstalacionMonitorizado+"/sagacom/estados_aparatos"]);
    },
    monitorizarInstalacion() {
      if (this.idInstalacion > 0)
        this.$sagabroker.altaSuscripcionTemas (["aparcamiento/"+this.idInstalacion+"/sagacom/estados_aparatos:70"]);

      if (this.idInstalacion != this.ultimoIdInstalacionMonitorizado) {
        this.$global.inicializarEstadoConexionAparatosInstalacion (this.idInstalacion);
        this.$sagabroker.solicitarActualizacionEstadoAparatos (this.idInstalacion);
      }
      this.ultimoIdInstalacionMonitorizado = this.idInstalacion;
    }
  },
  beforeMount() {
    // renovamos la orden de monitorización de la instalación cada 60 segundos
    this.idIntervalo = setInterval (() => { this.monitorizarInstalacion(); }, 60 * 1000);
    this.monitorizarInstalacion();
  },
  beforeDestroy() {
    if (this.idIntervalo)
      clearInterval (this.idIntervalo);
    this.desconectarDeUltimaInstalacion();
  },
}
</script>

<style>

</style>